<template>
  <v-container grid-list-md>

    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-select
          required
          label="Empresa"
          v-bind:items="empresas"
          v-model="unidade.empresa"
          item-text="nome"
          item-value="id"
          max-height="400"
          hint="Selecione a empresa"
          persistent-hint
          autocomplete
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm8>
        <v-text-field name="nome" required v-model="unidade.nome" label="Nome"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="cnpj" required v-model="unidade.cnpj" label="CNPJ"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field name="nomeFantasia" required v-model="unidade.nomeFantasia" label="Nome Fantasia"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field name="idSistema" v-model="unidade.idSistema" label="ID Sistema"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="intervaloStorage" required v-model="unidade.intervaloStorage" label="Storage"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field type="color" name="cor" v-model="unidade.cor" label="Cor"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field name="site" v-model="unidade.site" label="Site"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="email" v-model="unidade.email" label="Email"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field name="textoRodape"  v-model="unidade.textoRodape" label="Texto Rodapé"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="unidade.id">
      <v-flex xs12 sm4>
        <v-text-field prepend-icon="attach_file" single-line v-model="unidade.logoUrl" label="Logo" @click.native="onFocus" ref="fileTextField"></v-text-field>
        <input type="file" accept="*" :multiple="false" ref="fileInput" @change="onFileChange">
      </v-flex>

      <v-flex xs12 sm4>
        <v-text-field prepend-icon="attach_file" single-line v-model="unidade.carimboUrl" label="Carimbo" @click.native="onFocus2" ref="fileTextField"></v-text-field>
        <input type="file" accept="*" :multiple="false" ref="fileInput2" @change="onFileChange2">
      </v-flex>


    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-switch label="Ativo" color="primary" v-model="unidade.ativa"></v-switch>
      </v-flex>

      <v-flex xs12 sm4>
        <v-switch label="Assinar Exames" color="primary" v-model="unidade.assinatura"></v-switch>
      </v-flex>

      <v-flex xs12 sm4>
        <v-switch label="Remover Documento Assinatura" color="primary" v-model="unidade.removerDocumentoAssinatura"></v-switch>
      </v-flex>

    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-switch label="Adicionar QRCode" color="primary" v-model="unidade.qrcode"></v-switch>
      </v-flex>
      <v-flex xs12 sm4>
        <v-switch label="Whatsapp" color="primary" v-model="unidade.whatsapp"></v-switch>
      </v-flex>
      <v-flex xs12 sm4>
        <v-switch label="Pesquisa Satisfação" color="primary" v-model="unidade.pesquisa"></v-switch>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-select
                required
                label="Modelo QR Code"
                v-bind:items="modeloQRcodes"
                v-model="unidade.modeloQRcode"
                item-text="descricao"
                item-value="id"
                max-height="400"
                hint="Selecione o modelo de QRCode"
                persistent-hint
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="unidade.id">
      <v-flex xs12 sm4>
        <v-text-field name="tamanhoQr" v-model="unidade.tamanhoQr" label="Tamanho QRCode"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="xAss" v-model="unidade.xQr" label="Pos X QRCode"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="yQr" v-model="unidade.yQr" label="Pos Y QRCode"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="unidade.id">
      <v-flex xs12 sm4>
        <v-text-field name="tamanhoFont" v-model="unidade.tamanhoFont" label="Tamanho Fonte Assinatura"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="xAss" v-model="unidade.xAss" label="Pos X Assinatura"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="yAss" v-model="unidade.yAss" label="Pos Y Assinatura"></v-text-field>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>
import axios from 'axios'

export default {

  name: 'unidade-form',
  props: {
    unidade: {}
  },
  data () {
    return {
      empresas: [],
      modeloQRcodes: []
    }
  },
  components: {
  },
  methods: {
    pupularEmpresas () {
      var self = this
      axios.get('/empresas')
      .then(response => {
        self.empresas = response.data.list
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar empresas'
        self.snackbar = true
      })
    },
    popularModeloQRcode () {
      var self = this
      axios.get('/modeloQRcodes')
              .then(response => {
                self.modeloQRcodes = response.data
              })
              .catch(e => {
                self.tipoAlerta = 'error'
                self.textAlerta = 'Erro ao carregar modeloQRcodes'
                self.snackbar = true
              })
    },
    getFormData (files) {
      const data = new FormData()
      for (let file of files) {
        data.append('files[]', file, file.name)
      }
      return data
    },
    onFocus () {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFocus2 () {
      if (!this.disabled) {
        this.$refs.fileInput2.click()
      }
    },
    onFileChange ($event) {
      const files = $event.target.files || $event.dataTransfer.files
      const form = this.getFormData(files)
      if (files) {
        if (files.length > 0) {
          this.unidade.logoUrl = [...files].map(file => file.name).join(', ')
        }
      } else {
        this.unidade.logoUrl = $event.target.value.split('\\').pop()
      }
      this.unidade.formData = form
      // this.$emit('input', this.unidade.certificado)
      // this.$emit('formData', form)
    },
    onFileChange2 ($event) {
      const files = $event.target.files || $event.dataTransfer.files
      const form = this.getFormData(files)
      if (files) {
        if (files.length > 0) {
          this.unidade.carimboUrl = [...files].map(file => file.name).join(', ')
        }
      } else {
        this.unidade.carimboUrl = $event.target.value.split('\\').pop()
      }
      this.unidade.formData = form
      // this.$emit('input', this.unidade.certificado)
      // this.$emit('formData', form)
    }
  },
  created () {
    this.pupularEmpresas()
    this.popularModeloQRcode()
  }
}
</script>

<style scoped>

  input[type=file] {
      position: absolute;
      left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// UnidadeForm.vue?252ed202